import React from 'react';

// D-pad de déplacement de la vue (en bas à droite du canvas).
// Croix de 4 flèches autour d'un bouton central qui réinitialise le zoom à
// 100% et recentre la vue. Maintenir une flèche enfoncée déclenche un pan
// continu via setInterval (≈ 33 fps).
export default function ViewDPad({ setPan, setCanvas }) {
    const intervalRef = React.useRef(null);
    const PAN_STEP = 30;       // pixels par tick
    const PAN_TICK = 30;       // ms entre chaque tick (≈ 33 fps)

    const startPan = (dx, dy) => {
        // Premier déplacement immédiat, puis répété tant que la souris est down
        setPan(p => ({ x: p.x + dx, y: p.y + dy }));
        if (intervalRef.current) clearInterval(intervalRef.current);
        intervalRef.current = setInterval(() => {
            setPan(p => ({ x: p.x + dx, y: p.y + dy }));
        }, PAN_TICK);
    };
    const stopPan = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };
    React.useEffect(() => () => stopPan(), []);

    const dirBtn = (dx, dy, title, path) => (
        <button
            onMouseDown={(e) => { e.preventDefault(); startPan(dx, dy); }}
            onMouseUp={stopPan}
            onMouseLeave={stopPan}
            onTouchStart={(e) => { e.preventDefault(); startPan(dx, dy); }}
            onTouchEnd={stopPan}
            title={title} aria-label={title}
            className="w-8 h-8 flex items-center justify-center rounded-md bg-white/5 border border-white/10 text-white/70 hover:text-white hover:bg-white/10 active:bg-white/20 transition-colors"
        >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                {path}
            </svg>
        </button>
    );

    return (
        <div className="absolute right-6 bottom-6 z-[90] bg-black/40 backdrop-blur-md border border-white/10 rounded-xl p-1.5 shadow-lg">
            <div className="grid grid-cols-3 gap-1" style={{ gridTemplateColumns: '32px 32px 32px', gridTemplateRows: '32px 32px 32px' }}>
                <div />
                {dirBtn(0, PAN_STEP, "Déplacer la vue vers le haut", <polyline points="18 15 12 9 6 15"/>)}
                <div />
                {dirBtn(PAN_STEP, 0, "Déplacer la vue vers la gauche", <polyline points="15 18 9 12 15 6"/>)}
                <button
                    onClick={() => { setCanvas({ scale: 1 }); setPan({ x: 0, y: 0 }); }}
                    title="Réinitialiser zoom et position (1:1)"
                    className="w-8 h-8 flex items-center justify-center rounded-md bg-white/10 border border-white/20 text-white text-[9px] font-mono font-bold hover:bg-white/20 active:bg-white/30 transition-colors"
                >
                    1:1
                </button>
                {dirBtn(-PAN_STEP, 0, "Déplacer la vue vers la droite", <polyline points="9 18 15 12 9 6"/>)}
                <div />
                {dirBtn(0, -PAN_STEP, "Déplacer la vue vers le bas", <polyline points="6 9 12 15 18 9"/>)}
                <div />
            </div>
        </div>
    );
}
